import { render, staticRenderFns } from "./FinalGradeReviews.vue?vue&type=template&id=1ef01230&"
import script from "./FinalGradeReviews.vue?vue&type=script&lang=js&"
export * from "./FinalGradeReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports